export default function (str) {
    if (typeof str !== 'string') {
        return str;
    }
    return str.toLowerCase().replace(/_([a-z])/,  (match, p) => {
        return p.toUpperCase();
    });
}


// WEBPACK FOOTER //
// ./src/components/shared/hyphenToCamelCase.js